import BUSD_ABI from "../Contracts/BUSD_ABI.json";
import contractABI from "../Contracts/contract_ABI.json";
import tokenABI from "../Contracts/Token_ABI.json";
import ATMTokenABI from "../Contracts/ATMTokenABI.json";

// mainnet contract
const arr = {
  // contract: "0x185CC8F3C78eC6e440aB221ef71ba38971eB5585",
  contract: "0xfB8643A735ce7354111c1908641b7727d3b5d084",
  contractABI: contractABI,
  BUSD: "0x55d398326f99059fF775485246999027B3197955",
  BUSD_ABI: BUSD_ABI,
  ATMToken: "0x55d398326f99059fF775485246999027B3197955",
  BUSD: "0x55d398326f99059fF775485246999027B3197955",
  BUSD_ABI: BUSD_ABI,
  ATMToken: "0x55d398326f99059fF775485246999027B3197955",
  ATMTokenABI: ATMTokenABI,
};

////////////////testnet//////////////////
// const arr = {
//   contract: ",",
//   contractABI: contractABI,
//   BUSD: "0xa97f6c3e422a00a7a5B363340DF431b7d5412483",
//   BUSD_ABI: BUSD_ABI, //currently using this

//   token: "0x325a4deFFd64C92CF627Dd72d118f1b8361c5691 ",
//   tokenABI: tokenABI,
//   ATMToken: "0x325a4deFFd64C92CF627Dd72d118f1b8361c5691",
//   ATMTokenABI: ATMTokenABI,
// };

export const ContractDetails = arr;

// Action creators are generated for each case reducer function

export default ContractDetails;
